<template>
  <div>
    <v-col class="pt-5">
      <div>
        <v-row class="justify-center">
          <v-col cols="12" sm="8" md="7" class="pl-md-5 py-0 mt-5 mt-md-0">
            <v-card outlined elevation="0" class="py-3 px-3 rounded-lg psr-border">
              <div class="px-md-4">
                <div
                  class="text-center text-uppercase font-weight-bold text-h6 py-5 mb-2"
                  style="font-size: 1.15rem !important;"
                >
                  Halo,
                  <span class="black--text">{{userData.user_name}}</span> Ayo Isi Detail Tokomu!
                </div>
                <v-divider></v-divider>

                <v-form
                  ref="formRegisterStore"
                  role="form"
                  v-on:submit.prevent="onSubmit"
                  class="py-5"
                >
                  <div>
                    <div class="text-subtitle-2 font-weight-bold pb-1">Nama Toko</div>
                    <v-text-field
                      v-model="name"
                      :rules="nameRules"
                      color="black"
                      placeholder="Contoh: Toko Kain, Toko Baju Keren, dsb"
                      validate-on-blur
                      single-line
                      outlined
                      class="rounded-lg"
                      height="40"
                      dense
                      @focus="() => responseError.name=''"
                      @input="slugifyLink"
                      :error-messages="responseError.name"
                    ></v-text-field>
                  </div>
                  <div>
                    <div class="text-subtitle-2 font-weight-bold pb-1">Link Toko</div>
                    <v-row>
                      <v-col md="6" cols="12" class="py-0 pr-0 open-store-link">
                        <div class="text-subtitle-1 grey--text pt-1">tokogen.id/store/</div>
                      </v-col>
                      <v-col md="6" cols="12" class="py-0 open-store-link">
                        <v-text-field
                          v-model="link"
                          :rules="linkRules"
                          color="black"
                          validate-on-blur
                          single-line
                          outlined
                          class="rounded-lg"
                          height="40"
                          dense
                          @focus="() => responseError.slug=''"
                          :error-messages="responseError.slug"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                  <div>
                    <div class="text-subtitle-2 font-weight-bold pb-1">Deskripsi Toko</div>
                    <v-textarea
                      v-model="description"
                      :rules="descriptionRules"
                      color="black"
                      placeholder="Deskripsikan toko Anda"
                      outlined
                      class="rounded-lg"
                      dense
                      @focus="() => responseError.description=''"
                      :error-messages="responseError.description"
                      rows="2"
                      hint="Maksimal 200 karakter"
                      persistent-hint
                    ></v-textarea>
                  </div>
                  <div class="pb-4">
                    <div class="text-body-1 font-weight-bold pb-1">Provinsi</div>
                    <v-autocomplete
                      color="black"
                      v-model="province"
                      :rules="provinceRules"
                      :items="provinces"
                      item-text="provinsi_name"
                      return-object
                      single-line
                      outlined
                      validate-on-blur
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      hide-details="auto"
                      @focus="() => responseError.province_id=''"
                      :error-messages="responseError.province_id"
                      no-data-text="Tidak ada data"
                      @change="changeProvince"
                    ></v-autocomplete>
                  </div>
                  <div class="pb-4" v-if="province">
                    <div class="text-body-1 font-weight-bold pb-1">Kab / Kota</div>
                    <v-autocomplete
                      color="black"
                      v-model="city"
                      :rules="cityRules"
                      :items="cities"
                      :item-text="item => item.type + ' ' + item.kabupaten_name"
                      return-object
                      single-line
                      outlined
                      validate-on-blur
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      hide-details="auto"
                      @focus="() => responseError.city_id=''"
                      :error-messages="responseError.city_id"
                      no-data-text="Tidak ada data"
                      @change="changeCity"
                    >
                      <template v-slot:item="{item}">{{ item.type }} {{ item.kabupaten_name }}</template>
                      <template v-slot:selection="{item}">{{ item.type }} {{ item.kabupaten_name }}</template>
                    </v-autocomplete>
                  </div>
                  <div class="pb-4" v-if="city">
                    <div class="text-body-1 font-weight-bold pb-1">Kecamatan</div>
                    <v-autocomplete
                      color="black"
                      v-model="subdistrict"
                      :rules="subdistrictRules"
                      :items="subdistricts"
                      item-text="kecamatan_name"
                      return-object
                      single-line
                      outlined
                      validate-on-blur
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      hide-details="auto"
                      @focus="() => responseError.subdistrict_id=''"
                      :error-messages="responseError.subdistrict_id"
                      no-data-text="Tidak ada data"
                      @change="changeSubdistrict"
                    ></v-autocomplete>
                  </div>
                  <div class="pb-4" v-if="city">
                    <div class="text-body-1 font-weight-bold pb-1">Kode Pos</div>
                    <v-text-field
                      color="black"
                      v-model="zipcode"
                      :rules="zipcodeRules"
                      :items="zipcode"
                      item-text="kode"
                      return-object
                      single-line
                      outlined
                      validate-on-blur
                      class="rounded-lg text-body-1"
                      height="40"
                      dense
                      hide-details="auto"
                    ></v-text-field>
                  </div>
                  <div class="pb-4" v-if="city">
                    <div class="text-body-1 font-weight-bold pb-1">Alamat Lengkap</div>
                    <v-textarea
                      color="black"
                      v-model="address"
                      :rules="detail"
                      single-line
                      outlined
                      validate-on-blur
                      class="rounded-lg text-body-1"
                      placeholder="Isi nama jalan, nomor rumah, nama gedung, dsb"
                      hide-details="auto"
                      @focus="() => responseError.address=''"
                      :error-messages="responseError.address"
                      no-resize
                    ></v-textarea>
                  </div>
                  <div class="pb-4">
                    <div class="text-body-1 font-weight-bold pb-1">Atur Lokasi</div>
                    <v-col cols="6" class="pa-0">
                      <!-- <v-text-field
                      single-line
                      outlined
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      placeholder="Cari Lokasi"
                      hide-details="auto"
                      ></v-text-field>-->
                      <!-- <GoogleMap /> -->
                    </v-col>
                    <div class="pt-1">
                      <!-- <GoogleMap ref="gmap" /> -->
                      <div>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="#1951EF"
                            depressed
                            class="text-capitalize font-weight-bold rounded-sm green--text"
                            height="30"
                            width="120"
                            @click="geolocate"
                          >Lokasi Saya</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                        <br />
                        <div>
                          <!-- <h2>Search and add a pin</h2> -->
                          <GmapAutocomplete
                            single-line
                            outlined
                            :placeholder="'Cari Lokasi'"
                            style="width:100%;"
                            class="v-text-field"
                            @place_changed="setPlace"
                          />
                        </div>
                        <br />
                        <GmapMap
                          :center="center"
                          :zoom="18"
                          map-style-id="roadmap"
                          :options="mapOptions"
                          ref="mapRef"
                          @click="handleMapClick"
                          style="width:100%;  height: 200px;"
                        >
                          <GmapMarker
                            :position="marker.position"
                            :clickable="true"
                            :draggable="true"
                            @click="panToMarker"
                            @drag="handleMarkerDrag"
                          />
                        </GmapMap>
                      </div>
                      LatLon: {{latitude}}, {{longitude}}
                    </div>
                  </div>
                  <div class="pt-3">
                    <v-row>
                      <v-col cols="12" class="pt-1">
                        <v-checkbox
                          v-model="aggreement"
                          :rules="agreeRules"
                          class="small-check mt-0 black--text"
                        >
                          <template v-slot:label>
                            <div class="black--text">
                              Saya setuju dengan
                              <router-link
                                _target="_blank"
                                to="/page/syarat-dan-ketentuan"
                                class="black--text font-weight-bold"
                              >syarat dan ketentuan</router-link>, serta
                              <router-link
                                _target="_blank"
                                to="/page/kebijakan-privasi"
                                class="font-weight-bold black--text"
                              >kebijakan privasi Tokogen</router-link>
                            </div>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="pt-1">
                    <v-btn
                      v-if="isAttempting"
                      x-large
                      depressed
                      color="black"
                      class="col-12 rounded-lg"
                    >
                      <div class="subtitle-2 white--text">Sedang Diproses ...</div>
                    </v-btn>
                    <v-btn
                      v-else
                      x-large
                      depressed
                      color="black"
                      class="col-12 rounded-lg"
                      type="submit"
                    >
                      <div class="subtitle-2 white--text">Buka Toko</div>
                    </v-btn>
                  </div>
                </v-form>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      mapOptions: {
        disableDefaultUI: true,
        zoomControl: true
      },
      marker: { position: { lat: 45.508, lng: -73.587 } },
      center: { lat: 45.508, lng: -73.587 },
      currentPlace: null,
      markers: [],
      places: [],
      name: "",
      description: "",
      link: "",
      province: "",
      city: "",
      subdistrict: "",
      address: "",
      zipcode: "",
      aggreement: false,
      nameRules: [v => !!v || "Nama Toko tidak boleh kosong"],
      descriptionRules: [
        v => !!v || "Deskripsi tidak boleh kosong",
        v => v.length <= 200 || "Deskripsi maksimal 200 karakter"
      ],
      linkRules: [v => !!v || "Link Toko tidak boleh kosong"],
      provinceRules: [v => !!v || "Provinsi tidak boleh kosong"],
      cityRules: [v => !!v || "Kota tidak boleh kosong"],
      subdistrictRules: [v => !!v || "Kecamatan tidak boleh kosong"],
      zipcodeRules: [v => !!v || "Kode POS tidak boleh kosong"],
      detail: [
        v => !!v || "Alamat tidak boleh kosong",
        v => v.length > 20 || "Minimal 20 karakter"
      ],
      agreeRules: [v => !!v || ""]
    };
  },
  computed: {
    ...mapState("auth", ["userData"]),
    // ...mapState("options", ["provinces", "cities", "subdistricts"]),
    ...mapState("profile", ["isAttempting", "alerts", "responseError"]),
    latitude: {
      get() {
        return this.$store.state.kiriminaja.latitude;
      },
      set(newName) {
        return newName;
      }
    },
    longitude: {
      get() {
        return this.$store.state.kiriminaja.longitude;
      },
      set(newName) {
        return newName;
      }
    },
    ...mapState("kiriminaja", ["provinces", "cities", "subdistricts"])
  },
  methods: {
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
    },
    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      let data = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng()
      };
      this.actLatLon(data);

      // this.purchaseForm.header.header_recipient_latitude = data.latitude;
      // this.purchaseForm.header.header_recipient_longitude = data.longitude;

      // console.log(e);
    },
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      let data = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng()
      };
      this.actLatLon(data);

      // this.purchaseForm.header.header_recipient_latitude = data.latitude;
      // this.purchaseForm.header.header_recipient_longitude = data.longitude;
    },
    async setPlace(place) {
      this.currentPlace = await place;
      //   console.log("place", place);
      //   console.log("geometry", place.geometry.location.lat());
      this.center = await {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      let data = {
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      };
      this.actLatLon(data);
      this.marker.position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      this.panToMarker();
    },
    geolocate: function() {
      //   this.lokasi = "";
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        let data = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        this.actLatLon(data);
        //   await this.addMarker();
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.panToMarker();
      });
    },
    ...mapActions("kiriminaja", [
      "getProvince",
      "getCity",
      "getSubdistrict",
      "actLatLon"
    ]),
    // ...mapActions("options", ["getProvince", "getCity", "getSubdistrict"]),
    ...mapActions("profile", ["createStore"]),
    ...mapMutations("profile", ["clearProfile"]),
    ...mapMutations(["makeAlert"]),

    changeProvince() {
      this.city = null;
      this.subdistrict = null;
      this.getCity({
        province_id: this.province.id
      });
    },
    changeCity() {
      this.subdistrict = null;
      this.zipcode = null;
      this.getSubdistrict({
        city_id: this.city.id
      });
    },
    changeSubdistrict() {
      this.zipcode = this.subdistrict.postal_code;
    },
    onSubmit() {
      if (this.$refs.formRegisterStore.validate()) {
        // if (true) {
        let params = {
          name: this.name,
          slug: this.link,
          description: this.description,
          province_id: this.province.id,
          province_name: this.province.provinsi_name,
          city_id: this.city.id,
          city_name: this.city.type + " " + this.city.kabupaten_name,
          subdistrict_id: this.subdistrict.id,
          subdistrict_name: this.subdistrict.kecamatan_name,
          zipcode: this.zipcode,
          address: this.address,
          agregator: "kiriminaja"
        };
        this.createStore(params)
          .then(() => {
            this.$router.push({
              name: "seller-dashboard"
            });
            this.makeAlert({
              code: "success",
              type: "success",
              message: "Selamat toko anda berhasil dibuat",
              show: true
            });
          })
          .catch(() => {
            this.makeAlert({
              code: "error_response",
              type: "error",
              message: "Toko gagal dibuat. Cek pada field error dan sesuaikan",
              show: true
            });
          });
      }
    },
    slugifyLink() {
      this.responseError.slug = "";
      this.link = this.name
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-");
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Buka Toko");
    this.getProvince();
  },
  beforeDestroy() {
    this.clearProfile();
  }
};
</script>

	<style lang="scss" scoped>
.card-green-border {
  border-width: 3px;
  border-color: #00a651;
}
</style>